<div [style.height]="style().height" [style.width]="style().width" class="map-wrapper">
  <div #mapElement class="map"></div>
  <nav class="map-zoom">
    <button (click)="onZoomIn()" class="map-zoom-in"></button>
    <button (click)="onZoomOut()" class="map-zoom-out"></button>
  </nav>
</div>
